var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M579.4,489.3c2.59,2.74,2.98,40.4.84,44.72-1.93-2.43-2.67-36.95-.84-44.72Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.35,442.71c.33.9.96,1.8.96,2.7.03,13.63,0,27.25-.13,40.88,0,.42-1.17.82-2.29,1.56v-43.98c.49-.38.97-.77,1.46-1.15h0Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.83,526.64v42.49c-.98-1.17-2.12-1.89-2.12-2.62-.07-12.49-.01-24.98.07-37.47,0-.37.6-.73,2.05-2.4Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.84,527.91v41.31c-1.04-1.28-2.14-2.01-2.15-2.75-.09-12.32-.06-24.65,0-36.97,0-.55.58-1.09.89-1.64.42.02.84.04,1.25.05h0Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M603.82,569.94v41.31c-3.85-13.58-1.41-27.42-2.35-41.13.78-.06,1.57-.12,2.35-.18Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.86,492.45v42.32c-3.16-3.9-3.03-32.54,0-42.32h0Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.81,618.99v-37.02c.3-.16.6-.32.9-.47.59,1.04,1.55,2.02,1.7,3.11,1.38,10.17.1,31.8-2.6,34.38h0Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M596.2,476.72v33.38c-3.37-1.72-3.95-27.77,0-33.38Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.22,476.81v33.36c-3.42-1.88-3.94-28.01,0-33.36h0Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M611.53,628.68c-3.56-10.47-1.23-21.14-1.37-31.72,2.58,2.57,3.27,22.33,1.37,31.72Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.18,437.52v30.88c-3.76-1.74-3.68-22.99,0-30.88Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.29,537.76v34.48l-.81-.05v-34.47l.81.04h0Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M617.79,618.21v-36.35c.36,0,.72-.01,1.08-.02v36.36h-1.08Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.99,568.57c-3.26-3.18-3.35-21.08,0-25.37v25.37Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M596.17,542.64v25.37c-3.28-1.53-3.88-19.74,0-25.37Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.97,572.51v-25.47c3.52,3.5,3.47,21.86,0,25.47Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.16,604.74v21.71c-3.68-2.9-3.6-19.24,0-21.71Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7,495.29c-2.46-1.58-3.21-15.12-1.17-21.02,2.24,1.76,2.94,14.33,1.17,21.02Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M603.89,474.05v21.34c-2.84-1.77-3.41-16.9,0-21.34Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.92,574.02v21.26c-2.83-1.29-3.52-16.78,0-21.26Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M578.92,441.88v-21.26c3.42,1.72,3.69,18.25,0,21.26Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M632.98,566.19c3.51,3,3.33,19.04,0,21.38v-21.38Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M610.22,591.09v-22.14c3.42,5.76,2.9,20.15,0,22.14Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M195.02,493.53c3.35,3.05,3.41,17.74,0,21.14v-21.14Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M586.91,493.75c3.58,2.43,3.67,17.79,0,20.7v-20.7Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M588.55,447.1v21.16l-1.39-.02v-21.16c.46,0,.93.02,1.39.03h0Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M202.44,597.05c-.5-6.51-1.84-13,1.04-19.24.58,6.49,2.19,13-1.04,19.24Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M626.78,616.39v17.66h-1.45v-17.6c.48-.02.96-.05,1.45-.07h0Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M588.29,547.11c2.44,6.53.55,13.39,1.24,20.05-.57.05-1.14.09-1.71.14-.54-6.58-1.08-13.17-1.62-19.75.69-.15,1.39-.29,2.08-.44h.01Z",
    className: "patternColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.26,523.1v18.07c-3.51-1.6-3.91-14.03,0-18.07Z",
    className: "patternColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M181.26,577.07v18.01c-3.48-1.67-3.91-13.93,0-18.01Z",
    className: "patternColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.09,568.33c-3.44-2.57-3.57-14.3,0-17.86v17.86Z",
    className: "patternColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M626.87,580.02c-3.2-4.12-2.81-15.33,0-17.61v17.61Z",
    className: "patternColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.27,593.63v20.65h-1.27v-20.65h1.27Z",
    className: "patternColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M220.56,420.82c-.86,5.48,1.34,11.26-1.22,16.57-.68-.07-1.36-.13-2.03-.2.5-5.51,1-11.02,1.5-16.54.58.06,1.17.11,1.75.17Z",
    className: "patternColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M194.88,600.65c3.65,2.75,3.62,9.76,0,16.9v-16.9Z",
    className: "patternColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M579.28,458.78c2.53,1.33,3.03,5.25,1.7,13.39-2.68-.9-3.37-6.35-1.7-13.39Z",
    className: "patternColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M189.53,539.44c-.71,4.87,1.46,9.62-1.84,14.52-2.09-6.72-1.47-12.91,1.84-14.52Z",
    className: "patternColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M625.22,610.75v-13.69c.54-.01,1.08-.03,1.62-.04,1.16,4.51.72,9.08.26,13.65-.62.03-1.25.05-1.87.08h-.01Z",
    className: "patternColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M609.89,539.64c3.62,2.67,3.59,11.15,0,13.73v-13.73Z",
    className: "patternColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M609.89,504.71c3.58,2.51,3.63,10.96,0,13.72v-13.72h0Z",
    className: "patternColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M217.89,504.71c3.58,2.51,3.63,10.96,0,13.72v-13.72h0Z",
    className: "patternColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.34,627.44v-14.6c2.69,1.28,3.2,9.07,0,14.6Z",
    className: "patternColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M632.8,637.67v-13.89c3.6,2.22,3.78,10.58,0,13.89Z",
    className: "patternColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M586.8,487.9v-14.14c3.48,2.72,3.74,10.36,0,14.14Z",
    className: "patternColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M595.52,450.33c.42,4.56.84,9.12,1.26,13.68-.71.1-1.42.19-2.13.29-2.28-4.32-.46-9.26-1.11-13.83.66-.05,1.32-.09,1.98-.14Z",
    className: "patternColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M617.81,557.15v-17.43c.39.01.78.02,1.17.03v17.38c-.39,0-.78,0-1.17.01h0Z",
    className: "patternColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M595.79,535.36c-3.06-5.7-2.84-11.89,0-14.74v14.74Z",
    className: "patternColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.04,520.82v13.37c-3.52-3.83-3.31-11.12,0-13.37Z",
    className: "patternColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.31,487.13c.45-3.81.9-7.61,1.35-11.42.48.06.96.12,1.44.18.12,3.88,1.58,7.95-1.15,11.45-.55-.07-1.09-.14-1.64-.21h0Z",
    className: "patternColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M163.48,576.13l2.12-13.47c.11,4.61,2.33,9.53-.35,13.73l-1.77-.26h0Z",
    className: "patternColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M626.83,547v9.94c-.47.01-.93.03-1.4.04v-9.89c.47-.03.93-.06,1.4-.09h0Z",
    className: "patternColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M596.03,589.62c-1.39-4.11-4.34-7.73,0-12.94v12.94Z",
    className: "patternColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M627,591.39c-3.29-1.79-3.42-6.5,0-10.09v10.09Z",
    className: "patternColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M632.9,610.89v-10.29c3.41,2.65,3.58,7.31,0,10.29Z",
    className: "patternColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M587.03,531.43c3.13,3.12,3.16,7.1,0,10.3v-10.3Z",
    className: "patternColor"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M195.03,531.43c3.13,3.12,3.16,7.1,0,10.3v-10.3Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternK);
export default __webpack_public_path__ + "static/media/patternK.bb08ea68978b6b33f8846a5d60b99191.svg";
export { ForwardRef as ReactComponent };